// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__URGHE","type":"styles_type__26Q6F","choices":"styles_choices__3YoSj"};